export default {
    select: "Selecione o endereço de entrega",
    shippingRulesTip: "Você deve seguir as regras locais de embarque"
}